export const en = {
  hero: {
    title: "Trade Smarter with <span style='color: #38d102'>Phemex</span>",
    subtitle: "Professional Crypto Trading Strategies",
    startTrading: "Sign Up for Free",
    signUpForFree: "Sign Up for Free",
    learnMore: "Learn More",
    poweredBy: "Powered by",
    socialProof: "Join 50,000+ Traders"
  },
  promo: {
    signUp: "Sign up today and get",
    months: "3 MONTHS FREE",
    worth: "Worth 3x29$ • Save 87$",
    limitedTime: "Limited time offer! Expires soon"
  },
  whyMetrade: {
    title: "Why Choose METRADE",
    subtitle: "The perfect partner for your Phemex trading journey",
    reason1: {
      title: "Verified Strategies",
      description: "All premium strategies have proven track records and are thoroughly vetted"
    },
    reason2: {
      title: "Risk Management",
      description: "Advanced risk controls built into every premium strategy to protect your capital"
    },
    reason3: {
      title: "Swiss Quality",
      description: "Built in Switzerland with precision, reliability and security"
    },
    reason4: {
      title: "Seamless Integration",
      description: "Follow the strategy on your Phemex account with no technical knowledge required"
    },
    reason5: {
      title: "Full Transparency",
      description: "Access real-time performance data and complete trading history"
    },
    reason6: {
      title: "Expert Support",
      description: "Dedicated team of professionals ready to assist you"
    }
  },
  steps: {
    title: "Begin Your Trading Journey",
    subtitle: "Get started in three simple steps",
    step1: {
      title: "Sign up for free",
      description: "Create your account in seconds with just your email"
    },
    step2: {
      title: "Select a Strategy",
      description: "Browse strategies tailored specifically for Phemex traders"
    },
    step3: {
      title: "Connect and Start",
      description: "Select your strategy with our guided setup and begin trading"
    },
    joinText: "Join thousands of successful users on METRADE"
  },
  stats: {
    title: "Proven Performance",
    subtitle: "Our platform delivers consistent results for traders worldwide",
    activeUsers: "Active Users across 90+ countries",
    tradingVolume: "Trading Volume processed daily",
    successRate: "Satisfaction rate from surveys",
    support: "Priority Support with multiple languages"
  },
  features: {
    title: "METRADE Marketplace",
    subtitle: "Join thousands of successful users who have transformed their trading experience",
    feature1: {
      title: "Proven Strategies",
      description: "Access battle-tested trading strategies with verified success rates up to 92%"
    },
    feature2: {
      title: "Risk Management",
      description: "Pre-set risk parameters protect your capital during market volatility"
    },
    feature3: {
      title: "Select Strategy",
      description: "Select your strategy on Phemex and follow with 2 clicks"
    }
  },
  strategyShowcase: {
    title: "Top Performing Strategies",
    subtitle: "Discover our most successful trading strategies available on Phemex",
    viewAll: "View All Strategies",
    strategy1: {
      name: "Momentum Master",
      description: "Captures market trends with precision entry and exit points",
      roi: "+175% ROI in 2023",
      winRate: "76% Win Rate",
      riskLevel: "Medium Risk"
    },
    strategy2: {
      name: "Volatility Edge",
      description: "Thrives in volatile markets with adaptive trading parameters",
      roi: "+205% ROI in 2023",
      winRate: "81% Win Rate",
      riskLevel: "Medium-High Risk"
    },
    strategy3: {
      name: "Steady Growth",
      description: "Conservative approach focused on consistent returns",
      roi: "+90% ROI in 2023",
      winRate: "89% Win Rate",
      riskLevel: "Low Risk"
    },
    phemexCompatible: "Optimized for Phemex"
  },
  testimonials: {
    title: "Success Stories",
    subtitle: "Hear from traders who are already benefiting from our strategies",
    testimonial1: {
      quote: "Trading with METRADE through Phemex has completely changed my approach. The automated strategies consistently outperform my manual trading by a significant margin.",
      author: "Thomas R.",
      location: "Germany",
      strategy: ""
    },
    testimonial2: {
      quote: "The transparency of METRADE's platform combined with Phemex's powerful interface gives me complete confidence. I can see exactly how my investments are performing in real-time.",
      author: "Sophia L.",
      location: "Singapore",
      strategy: ""
    },
    testimonial3: {
      quote: "As someone new to crypto trading, the combination of Phemex and METRADE eliminated the guesswork. I'm now earning consistently without spending hours analyzing charts.",
      author: "David K.",
      location: "Canada",
      strategy: ""
    }
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Find answers to common questions about METRADE and Phemex integration",
    question1: {
      question: "How does the Phemex-METRADE integration work?",
      answer: "Our platform connects to your Phemex account through a secret Link with follow permissions. Once connected, the strategies you select will automatically execute trades on your behalf based on predefined parameters. You need a Phemex account to follow a strategy"
    },
    question2: {
      question: "What's the minimum capital required to start?",
      answer: "Minimum is 1800 USDT for a Free Strategy. Minimum 2300 USDT is a Premium Strategy with Risk Management."
    },
    question3: {
      question: "How can I monitor and control my risk?",
      answer: "Each Premium strategy comes with built-in risk management settings that you can review before activating. You can set maximum drawdown limits, and our platform will automatically stop trading if these limits are reached."
    },
    question5: {
      question: "What happens if I want to stop using a strategy?",
      answer: "You can pause or disconnect a strategy at any time with a single click. This will immediately stop any new trades, while giving you options for managing existing open positions."
    },
    question6: {
      question: "Are there any hidden fees?",
      answer: "No. We charge a transparent monthly subscription fee based on your chosen plan. There are no additional commissions on profits or hidden charges. You only pay the standard Phemex trading fees."
    }
  },
  footer: {
    copyright: "All rights reserved."
  },
  languageSelector: {
    language: "Language"
  },
  cta: {
    title: "Ready to transform your trading?",
    subtitle: "Start with a 3-month free trial today",
    buttonText: "Sign Up for Free",
    noCredit: "No credit card required for free trial"
  }
};
